import { Stack } from '@mui/material';
import ColoredAvatar from 'core/components/ColoredAvatar';
import { getFullName } from 'core/utils/commonUtils';
import PageHeaderBackLink from 'layout/pages/PageHeaderBackLink';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import type { User } from 'models/user/user';
import type { FC } from 'react';

const UserEditPageHeader: FC<UserEditPageHeaderProps> = ({ user }) => {
  const userNamePlug = user?.id === 0 ? 'Новый сотрудник' : 'Сотрудник';
  const userName = !isNil(user) ? getFullName(user) || userNamePlug : userNamePlug;

  return (
    <PageHeaderWrapper>
      <Stack spacing={2}>
        <PageHeaderBackLink to='/users' name='Сотрудники' />
        <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
          <ColoredAvatar alt={user?.surname}>{user?.surname?.[0]}</ColoredAvatar>
          <PageHeaderText text={userName} />
        </Stack>
      </Stack>
    </PageHeaderWrapper>
  );
};
export interface UserEditPageHeaderProps {
  user?: User;
}

export default UserEditPageHeader;
